import * as React from "react";
import { observer } from "mobx-react";
import {
  UserDataStoreContext,
} from "../../store";
import AddTaskIcon from "@mui/icons-material/AddTask";
import DatasetLinkedIcon from "@mui/icons-material/DatasetLinked";
import LogoutIcon from "@mui/icons-material/Logout";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";

const Nav = observer(({ onViewChange, activeView }) => {
  const userDataStore = React.useContext(UserDataStoreContext);

  let items = [
    {
      label: "Tasks",
      icon: <AddTaskIcon />,
      onClick: () => onViewChange("tasks"),
      active: activeView === "tasks",
    },
    {
      label: "Clients",
      icon: <DatasetLinkedIcon />,
      onClick: () => onViewChange("clients"),
      active: activeView === "clients",
    },
    {
      label: "Logout",
      icon: <LogoutIcon />,
      // Clears the backend SSO session and leaves for the sign-in screen
      onClick: () => userDataStore.logout(),
    },
  ];

  return (
    <List component="nav">
      <React.Fragment>
        {items.map((item) => (
          <ListItemButton
            key={item.label}
            onClick={item.onClick}
            selected={item.active}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </React.Fragment>
    </List>
  );
});

export default Nav;
